import React from 'react';
// import Header from './Components/Header';
import image from './../images/videoConference.jpg'


function Presentation(){
    return (
        <div id='presentation'>
            <img src={image} />
        </div>
    )
}

export default Presentation;